<template>
  <li>
    <button
    @click.prevent="switchCategory(subCategory)"
      class="flex px-6 py-2 font-medium text-gray-600 hover:text-red-700 transition-transform transform hover:translate-x-1"
      >{{ subCategory.name }}</button
    >
  </li>
</template>

<script>
export default {
  name: 'SubCategory',
  props: ['subCategory'],
  methods: {
    switchCategory (subCategory) {
      const payload = {
        id: subCategory.id,
        categorySlug: subCategory.slug,
        page: 1,
        sort: false
      }
      console.log(subCategory.id, 'subcategory')
      this.$store.dispatch('fetchTenants', payload)
    }
  }
}
</script>

<style>

</style>
